import { gql } from '@apollo/client';

export const INCOME_SOURCE_DELETED = gql`
  subscription incomeSourceDeleted {
    incomeSourceDeleted {
      incomeSourceId
    }
  }
`;
